module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-next-seo/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-mdx/gatsby-browser.js'),
      options: {"plugins":[],"extensions":[".mdx",".md"],"gatsbyRemarkPlugins":[{"resolve":"gatsby-remark-images","options":{"tracedSVG":{"color":"#3498DB"}}},"gatsby-remark-responsive-iframe",{"resolve":"gatsby-remark-autolink-headers","options":{"className":"custom-class","maintainCase":false,"removeAccents":true,"elements":["h2","h3","h4","h5"]}},{"resolve":"gatsby-remark-prismjs","options":{"aliases":{"sh":"bash","js":"javascript","py":"python"}}}]},
    },{
      plugin: require('../node_modules/gatsby-plugin-material-ui/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-typography/gatsby-browser.js'),
      options: {"plugins":[],"pathToConfigModule":"src/utils/typography"},
    },{
      plugin: require('../node_modules/gatsby-plugin-page-progress/gatsby-browser.js'),
      options: {"plugins":[],"includePaths":["/projects",{"regex":"^/blog"}],"excludePaths":[],"height":6,"prependToBody":false,"color":"#FF0000"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
